const GALLERY = {
  init: function () {
    this.slider = document.querySelector('.product__images');
    if (!this.slider) {
      return;
    }
    this.thumbnails = document.querySelectorAll('.product__thumbnails li');
    this.hasDoublePicture = window.innerWidth > 560;
    this.slider.addEventListener('scroll', () => {
      this.checkIndex();
    });
    this.checkIndex();
    this.navigation = document.querySelectorAll('.product__gallery--navigation span');
    this.navigation.forEach((nav) => {
      nav.addEventListener('click', this.handleNavigationClick.bind(this, nav));
    });
  },

  checkIndex: function () {
    const scrollPosition = this.slider.scrollLeft;
    const slideWidth = this.hasDoublePicture ? this.slider.offsetWidth / 2 : this.slider.offsetWidth;
    const index = Math.round(scrollPosition / slideWidth);
    this.thumbnails.forEach((thumbnail, i) => {
      if (i === index || (this.hasDoublePicture && i === index + 1)) {
        thumbnail.classList.add('product__thumbnail--is-active');
      } else {
        thumbnail.classList.remove('product__thumbnail--is-active');
      }
    });
  },

  handleNavigationClick: function (nav) {
    const slideWidth = this.hasDoublePicture ? this.slider.offsetWidth / 2 : this.slider.offsetWidth;
    if (nav.classList.contains('prev')) {
      this.slider.scrollLeft -= slideWidth;
    } else if (nav.classList.contains('next')) {
      this.slider.scrollLeft += slideWidth;
    }
  },
};

const SIZEEVENTS = {
  init: function () {
    this.sizeGuide = document.getElementById('size-guide');
    this.findYourSize = document.getElementById('usizy-button');
    this.findYourSizeFake = document.getElementById('usizy-fake-button');
    if (this.sizeGuide) {
      this.sizeGuide.addEventListener('click', this.handleSizeGuideClick.bind(this));
    }
    if (this.findYourSize) {
      this.findYourSize.addEventListener('click', this.handleFindYourSizeClick.bind(this));
    }
    if (this.findYourSizeFake) {
      this.findYourSizeFake.addEventListener('click', this.handleFindYourSizeClick.bind(this));
    }

    this.sizeLabels = document.querySelectorAll('.product__payment label');
    if (this.sizeLabels) {
      this.sizeLabels.forEach((sizeLabel) => {
        sizeLabel.addEventListener('click', this.handleSizeLabelClick.bind(this, sizeLabel));
      });
    }

    this.stickyVariant = document.getElementById('sticky-variant');
    if (this.stickyVariant) {
      this.stickyVariant.addEventListener('change', this.handleVariantChange.bind(this));
    }

    this.outOfStockVariants = document.querySelectorAll('.out-of-stock__variant');
    if (this.outOfStockVariants) {
      this.outOfStockVariants.forEach((outOfStockVariant) => {
        outOfStockVariant.addEventListener('click', this.handleOutOfStockClick.bind(this, outOfStockVariant));
      });
    }
  },

  handleSizeGuideClick: function (event) {
    event.preventDefault();
    const targetId = this.sizeGuide.getAttribute('href');
    const targetElement = document.querySelector(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
      const summary = targetElement.querySelector('summary');
      summary.click();
    }
  },


  handleFindYourSizeClick: function (event) {
    event.preventDefault();
    this.findYourSizeReal = document.querySelector('usizy-adviser').shadowRoot.querySelector('#info-window');
    if (this.findYourSizeReal) {
      this.findYourSizeReal.click();
    }
  },

  handleSizeLabelClick: function (sizeLabel, event) {
    const forValue = sizeLabel.getAttribute('for');
    const variantId = forValue.split('-').pop();
    const select = document.getElementById('sticky-variant');
    const optionToSelect = select.querySelector(`option[value="${variantId}"]`);
    if (optionToSelect) {
      select.value = variantId;
      const event = new Event('change', { bubbles: true });
      select.dispatchEvent(event);
    }
  },

  handleVariantChange: function (event) {
    const selectedValue = event.target.value;
    const correspondingLabel = document.querySelector(`label[for="product__variant--is-${selectedValue}"]`);
    if (correspondingLabel) {
      correspondingLabel.click();
    }
  },

  handleOutOfStockClick: function (event) {
    const outOfStockButtom = document.getElementById('BIS_trigger');
    outOfStockButtom.click();
  },
};

const STOCK = {
  init: function () {
    this.messages = document.querySelectorAll('.product__stock li');
    if (!this.messages) {
      return;
    }
    this.inputs = document.querySelectorAll('input[name="id"]');
    this.inputs.forEach((input) => {
      input.addEventListener('change', this.check.bind(this));
    });
    this.check();
  },

  check: function () {
    this.messages.forEach((message) => {
      STOCK.hide(message);
    });
    const selectedInput = document.querySelector('input[name="id"]:checked');
    if (selectedInput) {
      const selectedMessage = document.getElementById('product__stock--is-' + selectedInput.value);
      if (selectedMessage) {
        STOCK.show(selectedMessage);
      }
    }
  },

  hide: function (item) {
    item.setAttribute('class', 'visually-hidden');
  },

  show: function (item) {
    item.removeAttribute('class');
  },
};

const GENDER_SELECTOR = {
  init: function() {
    const genderSelectorMan = document.querySelector('#change-gender_men')?.querySelector('button');
    const genderSelectorWoman = document.querySelector('#change-gender_woman')?.querySelector('button');
    const params = new URLSearchParams(window.location.search);
    const isMobile = window.innerWidth < 1200;
    if (!genderSelectorMan || !genderSelectorWoman) return;

    if ((params.has('gender')) && (params.get('gender') === 'man')) {
      genderSelectorMan.classList.add('active');
    } else if ((params.has('gender')) && (params.get('gender') === 'woman')) {
      genderSelectorWoman.classList.add('active');
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  GALLERY.init();
  SIZEEVENTS.init();
  STOCK.init();
  GENDER_SELECTOR.init();
});
